import React, {Component} from 'react';
import {connect} from 'react-redux';

class Flags extends Component {
    render(){
        return (
            <div>
                <h3 className="font-300 font-24 text-white sm-bottom30 sm-top50">Student Alerts</h3>
                
            </div>
        )
    }
}


const mapStateToProps = state => ({
    ...state.auth,
    ...state.admin
});

const mapDispatchToProps = dispatch => ({

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Flags);


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Panels/Flags.js